/**
 * Re-exports all filter-related types from the shared type definitions.
 *
 * Import filter types from here, not from TableTemplateTypes directly.
 * This keeps field components inside the filter boundary and lets the type
 * source move in the future without touching every strategy file.
 */
export type {
  BooleanFilterDef,
  BooleanFilterValue,
  DateFilterDef,
  DateFilterValue,
  DateRangeFilterValue,
  FilterDef,
  FilterOp,
  FilterPanelProps,
  FilterState,
  FilterValue,
  ListFilterDef,
  ListFilterValue,
  ListOp,
  MonthYearFilterDef,
  MonthYearFilterValue,
  NumericFilterDef,
  NumericFilterValue,
  TextFilterDef,
  TextFilterValue,
} from '../ui/tableTemplate/TableTemplateTypes';
export type { LabeledCode } from '../../lib/labeledCode';

import type { FilterOp } from '../ui/tableTemplate/TableTemplateTypes';

/** Operator used for text (like) filter serialization. */
export const TEXT_FILTER_OP = 'like';

export type FilterOperatorOption = { value: FilterOp; label: string };

/** All comparison operators available for numeric and date filter inputs. */
export const FILTER_OPERATOR_OPTIONS: FilterOperatorOption[] = [
  { value: 'eq', label: '=' },
  { value: 'ne', label: '≠' },
  { value: 'gt', label: '>' },
  { value: 'gte', label: '≥' },
  { value: 'lt', label: '<' },
  { value: 'lte', label: '≤' },
];

/** Sentinel operator (date-only) that switches the value to a `dateRange`. */
export const BETWEEN = 'between';

/** Date operators: the six comparisons plus the date-only `between` (plage). */
export type DateOp = FilterOp | typeof BETWEEN;

export type DateOperatorOption = { value: DateOp; key: string };

/**
 * Date operator set shown in the panel — the seven comparisons incl. `between`.
 * `key` is the i18n suffix used as `table.filter.dateOp.<key>` (e.g. "≥ (à partir du)").
 * Order and i18n labels are intentional, so this is kept separate from
 * `FILTER_OPERATOR_OPTIONS` (symbol-based, numeric).
 */
export const DATE_OPERATOR_OPTIONS: DateOperatorOption[] = [
  { value: 'eq', key: 'eq' },
  { value: 'ne', key: 'ne' },
  { value: 'lt', key: 'lt' },
  { value: 'lte', key: 'lte' },
  { value: 'gt', key: 'gt' },
  { value: 'gte', key: 'gte' },
  { value: BETWEEN, key: 'between' },
];
